<div class="macth-preview-wrap" (click)="closeWidget()">
    <div class="widgetcont" id="matchPreviewWrap"(click)="$event.stopPropagation();" >
      <div><div class="sr-widget"></div></div>
    </div>
</div>
  